// SPA 라우트 변경 시 server.js가 주입한 SEO 메타 태그를 동기화한다.
// server.js의 주입은 첫 요청에만 적용되므로, client-side navigation 후에는 이 훅이 DOM을 갱신.

import { useEffect } from 'react';

import { useLocation } from 'react-router';

// eslint-disable-next-line boundaries/no-unknown-dependencies
import { resolveSeo } from '../../../seo.config.js';

// 값이 있으면 upsert, 없으면 기존 태그 제거 (이전 라우트의 stale 값 잔존 방지).
function upsertMeta(attrName: 'name' | 'property', key: string, value: string | null | undefined) {
  const existing = document.head.querySelector(`meta[${attrName}="${key}"]`);
  if (!value) {
    existing?.remove();
    return;
  }
  if (existing) {
    existing.setAttribute('content', value);
    return;
  }
  const el = document.createElement('meta');
  el.setAttribute(attrName, key);
  el.setAttribute('content', value);
  document.head.appendChild(el);
}

function upsertLink(rel: string, href: string | null | undefined) {
  const existing = document.head.querySelector(`link[rel="${rel}"]`);
  if (!href) {
    existing?.remove();
    return;
  }
  if (existing) {
    existing.setAttribute('href', href);
    return;
  }
  const el = document.createElement('link');
  el.setAttribute('rel', rel);
  el.setAttribute('href', href);
  document.head.appendChild(el);
}

export function useSeoSync() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = resolveSeo(pathname);

    document.title = seo.title;
    document.documentElement.lang = seo.lang;

    upsertMeta('name', 'description', seo.description);
    upsertMeta('name', 'keywords', seo.keywords);
    upsertLink('canonical', seo.canonical);

    upsertMeta('property', 'og:title', seo.title);
    upsertMeta('property', 'og:description', seo.description);
    upsertMeta('property', 'og:url', seo.canonical);
    upsertMeta('property', 'og:image', seo.ogImage);
    upsertMeta('property', 'og:locale', seo.ogLocale);

    upsertMeta('name', 'twitter:title', seo.title);
    upsertMeta('name', 'twitter:description', seo.description);
    upsertMeta('name', 'twitter:image', seo.ogImage);
  }, [pathname]);
}
